import { useEffect, useState } from "react";

interface CountdownTime {
  hours: string;
  minutes: string;
  seconds: string;
}

const getTargetDate = (currentDateTime: Date) => {
  const endOfUTCDaySeconds = Date.UTC(
    currentDateTime.getUTCFullYear(),
    currentDateTime.getUTCMonth(),
    currentDateTime.getUTCDate(),
    23,
    59,
    59,
    0,
  );

  return new Date(endOfUTCDaySeconds + 1000);
};

const formatTimeUnit = (unit: number): string => {
  return unit.toString().padStart(2, "0");
};

export const useCountdown = (): CountdownTime => {
  const [time, setTime] = useState<CountdownTime>({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const target = getTargetDate(now);
      const diff = target.getTime() - now.getTime();

      if (diff <= 0) {
        setTime({
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTime({
        hours: formatTimeUnit(hours),
        minutes: formatTimeUnit(minutes),
        seconds: formatTimeUnit(seconds),
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  return time;
};
